import { debounce } from 'lodash';
import API from './API';
import { logout } from './logout';
import { sendEvent } from './events';
import { HTTPRequestFactory, HTTPResponse } from 'hevy-shared/API';

export const initAPInterceptors = () => {
  API.attachErrorHandler(invalidLegacyTokenLogoutInterceptor);
  API.attachErrorHandler(tokenRefreshFailedLogoutHandler);
  API.attachErrorHandler(invalidTokenLogoutHandler);
};

const invalidLegacyTokenLogoutInterceptor = ({ status, data }: HTTPResponse) => {
  if (status === 401 && data === 'InvalidAuthToken') {
    debouncedLogout('⚠️ Found invalid auth-token');
  }
};

const tokenRefreshFailedLogoutHandler = (
  { status }: HTTPResponse,
  { method, url }: HTTPRequestFactory,
) => {
  if (
    status === 401 &&
    method === API.refreshAuthTokenApiEndpoint.method &&
    url === API.refreshAuthTokenApiEndpoint.url
  ) {
    // If refreshing the auth token ever fails with a 401, we log the user out.
    debouncedLogout('⚠️ Failed to refresh auth tokens');
  }
};

const invalidTokenLogoutHandler = (
  response: HTTPResponse,
  _request: HTTPRequestFactory,
  { isTokenRefreshedAfterRequest }: { isTokenRefreshedAfterRequest: boolean },
) => {
  if (API.isAccessTokenInvalidResponse(response) && !isTokenRefreshedAfterRequest) {
    debouncedLogout('⚠️ Found invalid access_token');
  }
};

const debouncedLogout = debounce(
  (message: string) => {
    sendEvent('invalid-auth-token-logout');
    console.warn(message);
    logout({ isUserInitiated: false });
  },
  5000,
  {
    leading: true,
    trailing: false,
  },
);
